<template>
  <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
    <feather-icon icon="EyeIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="ViewRecord" />
    <!--<feather-icon v-if="!this.params.data.islocked && !loginRole.includes('accountant')" icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord" />-->
  </div>
</template>

<script>
export default {
name: 'CellRendererActions',
data() {
  return {
    loginRole: '' // Initialisation de la variable loginRole
  }
},
mounted() {
  // On récupère les rôles depuis localStorage dans le lifecycle hook
  const role = localStorage.getItem('login-roles');
  if (role) {
    this.loginRole = role.toLowerCase(); // Assigne la valeur convertie en minuscule
  }
},
methods: {
  editRecord () {
      this.$router.push("/broker/invoice-edit/" + this.params.data.id).catch(() => {})
  },
  ViewRecord () {
      this.$router.push("/broker/invoice/" + this.params.data.id).catch(() => {})
  }
}
//!localStorage.getItem('login-roles').toLowerCase().includes('accountant')
}
</script>

